import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import FBPostCRUDActions from '../actions/FBPostCRUDActions';
import { NOT_FOUND } from '@mm/constants/status-codes';
import commonHandler, { ResponseOrError } from './common-handler';

export default (dispatch: Dispatch<StoreState>) => (error: ResponseOrError) => {
  if (error instanceof Response && error.status === NOT_FOUND) {
    dispatch(FBPostCRUDActions.unbusy());
  } else {
    commonHandler(dispatch)(error);
  }
};
